import Vue from 'vue'
import VueRouter from 'vue-router'
import moveList from './moveScreen'
import yiqi from './yiqi'
import wms from './wms'
import enterpriseList from './enterprise'
import {bankScreen} from './bankScreen'

import wenList from './wenScreen'
Vue.use(VueRouter)

const routes = [
    //     {
    //     path: '/',
    //     name: 'login1',
    //     component: () => import('../views/login1.vue')
    // }, 
    {
        path: '/404',
        name: '404',
        component: () => import('../views/404.vue')
    },
    {
        path: '/nmlogin',
        name: 'login1',
        component: () => import('../views/login1.vue')
    },
    {
        path: '/nmzlqlogin',
        name: 'login2',
        component: () => import('../views/login2.vue')
    },
    //----阿尔善宝力格镇----
    {
        path: '/ablogin',
        name: 'login3',
        component: () => import('../views/login3.vue')
    },
    {
        path: '/xnlogin',
        name: 'login5',
        component: () => import('../views/login5.vue')
    },
    {
        path: '/Aershan',
        name: 'Aershan',
        meta: {
            activeNav: 'Aershan',
        },
        component: () => import('../views/Aershan/index.vue')
    },
    {
        path: '/details2',
        name: 'details2',
        meta: {
            activeNav: 'details2',
        },
        component: () => import('../views/Aershan/details.vue')
    },
    {
        path: '/archives2',
        name: 'archives2',
        meta: {
            activeNav: 'archives2',
        },
        component: () => import('../views/Aershan/archives.vue')
    },
  

    //通辽大屏
    {
        path: '/industry',
        name: 'industry',
        meta: {
            activeNav: 'industry',
        },
        component: () => import('../views/industry/index.vue')
    },
    {
        path: '/source',
        name: 'source',
        meta: {
            activeNav: 'source',
        },
        component: () => import('../views/operate/source.vue')
    },
    //通辽大屏

    {
        path: '/operate',
        name: 'operate',
        meta: {
            activeNav: 'operateIndex',
        },
        component: () => import('../views/operate/index.vue')
    }, {
        path: '/traceIndex',
        name: 'traceIndex',
        meta: {
            activeNav: 'traceIndex',
        },
        component: () => import('../views/operate/traceIndex.vue')
    }, {
        path: '/traceInfo',
        name: 'traceInfo',
        meta: {
            activeNav: 'traceIndex',
        },
        component: () => import('../views/operate/traceInfo.vue')
    },
    {
        path: '/financial',
        name: 'financial',
        meta: {
            activeNav: 'financialIndex',
        },
        component: () => import('@/views/financial/index.vue')
    }, {
        path: '/transaction',
        name: 'transaction',
        meta: {
            activeNav: 'transactionIndex',
        },
        component: () => import('../views/transaction/index.vue')
    }, {
        path: '/user',
        name: 'user',
        meta: {
            activeNav: 'userIndex',
        },
        component: () => import('../views/user/index.vue')
    }, {
        path: '/userInfo',
        name: 'userInfo',
        meta: {
            activeNav: 'userIndex',
        },
        component: () => import('../views/user/info.vue')
    }, {
        path: '/empty',
        name: 'empty',
        meta: {
            activeNav: 'empty',
        },
        component: () => import('../views/empty/index.vue')
    },
    {
        path: '/livestock',
        name: 'livestock',
        meta: {
            activeNav: 'livestock',
        },
        component: () => import('../views/livestock/index.vue')
    },
    {
        path: '/slaughter',
        name: 'slaughter',
        meta: {
            activeNav: 'slaughter',
        },
        component: () => import('../views/slaughter/index.vue')
    },
    {
        path: '/detail',
        name: 'detail',
        meta: {
            activeNav: 'slaughter',
        },
        component: () => import('../views/slaughter/detail.vue')
    },
    {
        path: '/empty_3',
        name: 'empty_3',
        meta: {
            activeNav: 'empty_3',
        },
        component: () => import('../views/empty_3/index.vue')
    },
    {
        path: '/general',
        name: 'general',
        meta: {
            activeNav: 'general',
        },
        component: () => import('../views/general/index.vue')
    }, {
        path: '/partner',
        name: 'partner',
        component: () => import('../views/partner/index.vue')
    },
    {
        path: '/breeder',
        name: 'breeder',
        meta: {
            activeNav: 'breederIndex',
        },
        component: () => import('../views/breeder/index.vue')
    },
    {
        path: '/details',
        name: 'details',
        meta: {
            activeNav: 'breederIndex',
        },
        component: () => import('../views/breeder/details.vue')
    },
    {
        path: '/archives',
        name: 'archives',
        meta: {
            activeNav: 'breederIndex',
        },
        component: () => import('../views/breeder/archives.vue')
    },
    ...moveList,
    ...yiqi,
	...wms,
    ...enterpriseList,
    ...bankScreen,
    ...wenList
]
const router = new VueRouter({
    mode: "history",
    routes
})

export default router